/**
 * How long ago an account last ordered, in words: "last order 3 days ago",
 * "last order yesterday", "last order today", or "no orders yet". Used by
 * the account list (mid-sentence, lowercase) and the account page header
 * (start of a phrase, capitalized).
 */

import type { TFunction } from "i18next";
import { count } from "../format";

/** "list" for lowercase wording mid-line; "account" for capitalized wording. */
export type LastOrderWording = "list" | "account";

export function lastOrderText(
  t: TFunction,
  days: number | null,
  wording: LastOrderWording,
): string {
  // Text keys for the chosen wording, e.g. pages.pcInsights.list.lastOrderToday
  const key = (name: string) => `pages.pcInsights.${wording}.${name}`;
  // Never ordered
  if (days === null) return t(key("noOrders"));
  // Ordered on the data's as-of date
  if (days === 0) return t(key("lastOrderToday"));
  // The day before
  if (days === 1) return t(key("lastOrderYesterday"));
  // Any longer
  return t(key("lastOrderDaysAgo"), { days: count(days) });
}
